import { render, staticRenderFns } from "./CertificateDesign.vue?vue&type=template&id=69646231&scoped=true&"
import script from "./CertificateDesign.vue?vue&type=script&lang=js&"
export * from "./CertificateDesign.vue?vue&type=script&lang=js&"
import style0 from "./CertificateDesign.vue?vue&type=style&index=0&id=69646231&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69646231",
  null
  
)

export default component.exports